import React from 'react';
import AddUser from '../Components/AddUser';
import "./pages.css";
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'Home',
    href: '/',
    className: 'breadcrumb-link',
  },
  {
    name: 'Users',
    href: '/admin/users',
    className: 'breadcrumb-link',
  },
  {
    name: 'Add User',
    href: '',
    isCurrent: true,
    className: 'breadcrumb-current',
  },
];

const AddUsers = () => {
  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <AddUser />
    </>
  );
}

export default AddUsers;
